import "@ruter-as/web-components-and-tools/dist/index.css";
import {
	apiClient,
	LanguageContextProvider,
} from "@ruter-as/web-components-and-tools";
import * as Sentry from "@sentry/react";
import { setDefaultOptions } from "date-fns";
import { nb } from "date-fns/locale";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import App from "./components/App";
import AuthContextProvider from "./components/auth/Auth.component";
import GenericError from "./components/error/GenericError";
import { getEnv } from "./env";

const env = getEnv();

Sentry.init({
	dsn: "https://042f1d9190c9159bfd519b5f3ab3004a@o268620.ingest.us.sentry.io/4508155128315904",
	environment: env.envName,
	normalizeDepth: 10,
	release: env.release,
	integrations: window.Cypress
		? []
		: [
				Sentry.browserProfilingIntegration(),
				Sentry.browserTracingIntegration(),
				Sentry.replayIntegration(),
			],
	tracesSampleRate: 1.0,
	profilesSampleRate: 1.0,
});

setDefaultOptions({ locale: nb });

apiClient.setAuthenticationService({
	getAccessToken: async () => await Promise.resolve(""),
	login: async () => {
		await Promise.resolve();
	},
});

const domNode = document.getElementById("app");
if (domNode !== null) {
	const root = createRoot(domNode);

	root.render(
		<Sentry.ErrorBoundary
			fallback={(error) => <GenericError error={error.error as Error} />}
		>
			<BrowserRouter>
				<LanguageContextProvider
					availableLanguages={["nb"]}
					defaultLanguage={"nb"}
				>
					<AuthContextProvider>
						<App />
					</AuthContextProvider>
				</LanguageContextProvider>
			</BrowserRouter>
		</Sentry.ErrorBoundary>,
	);
}
